let {Hand} = require('./hand')

export class Player {

    constructor(id, hand) {
        if (!(hand instanceof Hand)) {
            throw Error('Player hand must be Hand object');
        }
        this.id = id;
        this.hand = hand;
    }
}